import { render, staticRenderFns } from "./Answer.vue?vue&type=template&id=a560f656&scoped=true&"
import script from "./Answer.vue?vue&type=script&lang=js&"
export * from "./Answer.vue?vue&type=script&lang=js&"
import style0 from "./Answer.vue?vue&type=style&index=0&id=a560f656&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a560f656",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormElement: require('/home/vsts/work/1/s/components/FormElement.vue').default})
